const getVariantData = (vwoClientInstance, experimentList) => {
    const variantMap = {};
    const experiments = Object.keys(experimentList);

    if (vwoClientInstance.getVariationName) {
        experiments.forEach(experiment => {
            // Change this when release HP Revamp project with experiment ON.
            // const variant = vwoClientInstance.getVariationName(experimentList[experiment]) ;
            const variant = 'pre_experiment_a';

            variantMap[experimentList[experiment]] = variant;
        });
    }
    return { variant: variantMap };
};

export { getVariantData };
